"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function ExperienceUnmatchedLuxuryWithOurFleet() {
  const heroRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const [isHoveringCTA, setIsHoveringCTA] = useState(false);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    const handleMouseMove = (e: MouseEvent) => {
      setMousePos({
        x: e.clientX,
        y: e.clientY
      });
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    window.addEventListener("mousemove", handleMouseMove, {
      passive: true
    });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);
  const vehicles = [{
    name: "Luxury Sedan",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/luxury_sedan_silhouette.png"
  }, {
    name: "Premium SUV",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/premium_suv_silhouette.png"
  }, {
    name: "Executive SUV",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/executive_suv_silhouette.png"
  }];
  return <section ref={heroRef} className="relative min-h-screen w-full overflow-hidden bg-background" onMouseEnter={() => setIsHoveringCTA(false)}>
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[2000ms] ease-out" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/fleet_at_dusk_backdrop.png)",
      transform: isHoveringCTA ? "scale(1)" : `translateY(${scrollY * 0.3}px) scale(1.05)`
    }}>
        <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-background/30 to-background/60" />
      </div>

      {}
      <div ref={contentRef} className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 py-16 text-center">
        {}
        <h1 className={`font-display text-4xl font-bold text-foreground transition-all duration-300 md:text-6xl lg:text-7xl ${isVisible ? "animate-fade-in-up" : "opacity-0"}`}>
          Experience Unmatched Luxury <br className="hidden sm:block" />
          with Our Fleet
        </h1>

        <p className={`mt-6 max-w-2xl text-lg text-foreground/90 transition-all duration-300 md:text-xl ${isVisible ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>Premium transportation across Connecticut, New York City, Long Island, and New Jersey. Luxury Sedans and SUVs, Available 24/7.</p>

        {}
        

        {}
        <div className="relative mt-12" onMouseEnter={() => setIsHoveringCTA(true)} onMouseLeave={() => setIsHoveringCTA(false)}>
          <Link to="/FleetPage">
            <Button size="lg" className="btn-primary relative overflow-hidden px-8 py-4 text-base font-bold shadow-strong transition-all duration-300 ease-[var(--ease-spring)] hover:scale-105 focus-visible:ring-accent/60 md:px-10 md:py-5 md:text-lg" style={{
            animation: isHoveringCTA ? "pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite" : "none"
          }}>
              Explore Our Fleet
            </Button>
          </Link>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
          }
          50% {
            transform: scale(1.03);
            box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
          }
        }
      `}</style>
    </section>;
}